const React = require('react');
const PropTypes = require('prop-types');
require ('./bottomBarCC.scss');


class BottomBarCC extends React.Component {
    render() {
        const {clientName } = this.props;
        return (
            <div className="container-bottombarcc">
                <a  href={'/myprofile/global'} className="openbank-topbar__logo" title="Openbank: Banco Online del Grupo Santander"></a>
                <div className="container-bottombarcc__right-buttons">
                    <div className="container-bottombarcc__exit">
                        <p className="container-bottombarcc__client-name">{clientName}</p>
                    </div>
                </div>
            </div>
       );
    }
}

BottomBarCC.propTypes = {
    clientName: PropTypes.string
};


module.exports = BottomBarCC;
